/** @format */

import React, { useState, useEffect } from 'react';
import { Card, Divider, Input, Upload, message, Button, Row, Col } from 'antd';
import { CopyOutlined, InboxOutlined, FilePdfOutlined } from '@ant-design/icons';
// import { CustomNotification } from '../../../../../v2-components/Antd/Notification';
import './style.scss';
import Text from 'antd/lib/typography/Text';

const { Dragger } = Upload;

const BankTransferDetails = ({ onFileUpload, isValidation, setIsValidation }) => {
	console.log('isValidation', isValidation);
	const [file, setFile] = useState(null);
	const [preview, setPreview] = useState(null);

	const transferData = [
		{ label: 'Razón Social', value: 'Farmacann Spa' },
		{ label: 'Entidad bancaria', value: 'BCI' },
		{ label: 'Cuenta corriente', value: '63336421' },
		{ label: 'RUT', value: '77.054.137-9' },
		{ label: 'E-mail de confirmación', value: 'contacto@narma.cl' },
	];

	const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
	const maxSizeMB = 20;

	const handleCopy = (label, value) => {
		navigator.clipboard.writeText(value);
		// Descomenta tu CustomNotification cuando la vayas a usar
		/*
        CustomNotification({
            type: 'success',
            message: '¡Copiado!',
            description: `${label} ha sido copiado al portapapeles.`,
            duration: 3,
        });
        */
	};

	const handleBeforeUpload = (currentFile) => {
		if (!validTypes.includes(currentFile.type)) {
			message.error('Solo se permiten archivos JPG, JPEG, PNG o PDF');
			return Upload.LIST_IGNORE;
		}
		if (currentFile.size / 1024 / 1024 >= maxSizeMB) {
			message.error(`El archivo debe ser menor a ${maxSizeMB} MB`);
			return Upload.LIST_IGNORE;
		}

		// Limpiamos la URL anterior de la memoria si existe
		if (preview?.url) {
			URL.revokeObjectURL(preview.url);
		}

		const url = URL.createObjectURL(currentFile);
		setPreview({ url, type: currentFile.type, name: currentFile.name });
		setFile(currentFile);
		if (onFileUpload) onFileUpload(currentFile);
		setIsValidation(false); // Reseteamos la validación al subir un nuevo archivo

		return false; // Retornamos false para evitar que Antd intente subirlo automáticamente
	};

	const handleRemove = (e) => {
		e.stopPropagation(); // Evita que al hacer clic en eliminar se abra la ventana de subir archivo
		if (preview?.url) {
			URL.revokeObjectURL(preview.url);
		}
		setFile(null);
		setPreview(null);
		if (onFileUpload) onFileUpload(null);
		message.info('Archivo eliminado');
	};

	// Limpieza de memoria cuando el componente se desmonta
	useEffect(() => {
		return () => {
			if (preview?.url) {
				URL.revokeObjectURL(preview.url);
			}
		};
	}, [preview]);

	return (
		<Card className="ph-transfer-card-container">
			<p className="ph-transfer-card-title">Datos para la transferencia</p>
			<Divider className="ph-transfer-card-divider" />

			<div className="ph-transfer-card-content">
				{transferData.map((item, index) => (
					<div key={index} className="ph-transfer-field">
						<label className="ph-transfer-label">{item.label}</label>
						<Input
							readOnly
							size="large"
							value={item.value}
							className="ph-transfer-input-square"
							suffix={index === 1 ? null : <CopyOutlined className="ph-transfer-copy-icon" onClick={() => handleCopy(item.label, item.value)} />}
						/>
					</div>
				))}
			</div>

			<div className="ph-transfer-upload-section">
				<p className="ph-transfer-card-title" style={{ marginTop: '24px', marginBottom: '16px' }}>
					Sube tu comprobante de pago
				</p>
				{/* === UI estilo Magistral (1 archivo) === */}
				<Dragger
					name="file"
					accept=".jpg,.jpeg,.png,.pdf"
					showUploadList={false}
					beforeUpload={handleBeforeUpload}
					className="upload-dragger ph-transfer-upload-dragger-magistral"
				>
					{preview ? (
						preview.type === 'application/pdf' ? (
							<div style={{ textAlign: 'center', padding: '20px' }}>
								<FilePdfOutlined style={{ fontSize: 48, color: '#e74c3c' }} />
								<p style={{ marginTop: 8, color: '#666' }}>Archivo PDF cargado correctamente</p>
							</div>
						) : (
							<div className="image-preview">
								<img src={preview.url} alt={preview.name} className="preview-image" />
							</div>
						)
					) : (
						<>
							<p className="ant-upload-drag-icon">
								<InboxOutlined />
							</p>
							<p className="ant-upload-text">Haz clic o arrastra el archivo aquí</p>
							<p className="ph-upload-help">Formato: JPG, JPEG, PNG, PDF (Máx. 20 MB)</p>
						</>
					)}
				</Dragger>

				{/* “Lista” estilo Magistral (pero 1 archivo) */}
				<div className="file-list ph-transfer-filelist-magistral">
					{!file ? (
						<Text type="secondary">Sin archivos cargados</Text>
					) : (
						<Row align="middle" justify="space-between" className="file-row file-row-active" style={{ padding: '8px 0', paddingLeft: '8px' }}>
							<Col span={16}>
								<Button type="link" className="file-link" style={{ padding: 0 }}>
									{preview?.type === 'application/pdf' ? <FilePdfOutlined style={{ marginRight: 6 }} /> : null}
									<span className="file-name">{preview?.name || file?.name}</span>
								</Button>
							</Col>
							<Col span={8} style={{ textAlign: 'right' }}>
								<Button type="text" danger onClick={handleRemove}>
									Eliminar
								</Button>
							</Col>
						</Row>
					)}
				</div>
				{isValidation && <div style={{ color: 'red', marginTop: '12px' }}>Adjunta un comprobante de pago válido</div>}
			</div>
		</Card>
	);
};

export default BankTransferDetails;
